'use strict';

var _ = require('lodash');

// http://en.wikipedia.org/wiki/Tarjan%27s_strongly_connected_components_algorithm

var CustomColumnCycleDetectionService = function CustomColumnCycleDetectionService(columnIterator) {
  function getCycles(jqxColumns) {
    var foundCycles = [];
    var s = [];
    var index = 0;
    var indexes = {};
    var lowLinks = {};

    // prepare a map for a quick column search
    var map = {};
    columnIterator.forEachColumn(jqxColumns, function (col) {
      map[col.field] = col;
    });

    // add a column defined in an 'operand' property to 'nodes'
    function addAdjNode(nodes, col, operand) {
      var value = col.formula[operand];
      if (_.isString(value) && map[value]) {
        nodes.push(map[value]);
      }
    }

    // return all adjacent nodes for a column 'col'
    function getAdjNodes(col) {
      var nodes = [];
      if (col.formula !== undefined) {
        addAdjNode(nodes, col, 'leftOperand');
        addAdjNode(nodes, col, 'rightOperand');
      }
      return nodes;
    }

    // throw an exception with the first found strongly connected group (a detected cycle)
    function strongConnected(col) {
      index++;
      indexes[col.field] = index;
      lowLinks[col.field] = index;
      s.push(col.field);
      getAdjNodes(col).forEach(function (node) {
        if (indexes[node.field] === undefined) {
          strongConnected(node);
          lowLinks[col.field] = Math.min(lowLinks[col.field], lowLinks[node.field]);
        } else if (_.indexOf(s, node.field) !== -1) {
          lowLinks[col.field] = Math.min(lowLinks[col.field], indexes[node.field]);
        }
      });

      // SCC of a size of two and more is a cycle
      if (lowLinks[col.field] === indexes[col.field]) {
        var node,
          scc = [];
        do {
          node = s.pop();
          scc.push(node);
        } while (node !== col.field);
        if (scc.length > 1) {
          foundCycles.push(scc);
        }
      }
    }
    columnIterator.forEachColumn(jqxColumns, function (col) {
      if (indexes[col.field] === undefined) {
        strongConnected(col);
      }
    });
    return foundCycles;
  }
  return {
    // an empty array means no cycle
    getCycles: getCycles
  };
};
CustomColumnCycleDetectionService.$inject = ['ColumnIteratorService'];
module.exports = CustomColumnCycleDetectionService;